import { Layout as BaseLayout } from '@startupquickstart/frontend';
import { Outlet } from 'react-router-dom';
import { AppStandardSidebar } from '../AppStandardSidebar';
import { SidebarSetup } from '../SidebarSetup';

export function Layout() {
  return (
    <>
      <SidebarSetup />
      <BaseLayout sidebar={<AppStandardSidebar />}>
        <Outlet />
      </BaseLayout>
    </>
  );
}
